// QC report — check points per photo section.
// Each section can have its own typed check points (saved on the section). A section that
// was never edited shows the standard points for its name, so older reports print as before.
export const SECTION_GUIDE = [
  [/drawing/i, ['Verify all dimensions', 'Match with latest revision', 'Check critical details', 'Confirm hardware locations', 'Ensure finish & material notes']],
  [/product\s*image|actual/i, ['Overall appearance', 'Finish & colour matching', 'No visible defects', 'Correct orientation', 'As per approved sample']],
  [/front/i, ['Dimensions (height & width)', 'Panel alignment', 'Finish quality', 'Edge profile', 'Hardware fitment']],
  [/side/i, ['Side panel finish', 'Joint & gap consistency', 'Top surface alignment', 'Edge quality', 'Stability / level']],
  [/back/i, ['Back panel quality', 'Cut-outs / cable opening', 'Joint finishing', 'Stability', 'No damage or scratches']],
  [/dimension/i, ['Height, width, depth', 'All critical dimensions', 'As per approved drawing', 'Tolerance within limits']],
  [/finish|sample|shade/i, ['Shade matches approved sample', 'Sheen level', 'Uniform colour & grain', 'No patches or runs']],
  [/rub/i, ['No colour transfer', 'Coating intact after rubbing', 'No peeling or whitening']],
  [/nail/i, ['Nails flush / punched', 'No protruding nails', 'Secure holding']],
  [/smell|odou?r/i, ['No strong solvent smell', 'Finish fully cured', 'Fit for packing']],
];
export const guideFor = name => (SECTION_GUIDE.find(([re]) => re.test(name || '')) || [])[1] || null;

// Saved points (array) — or null when the section was never edited
export const savedPoints = sec => {
  const v = sec?.check_points;
  if (Array.isArray(v)) return v;
  if (typeof v === 'string' && v.trim()) { try { const a = JSON.parse(v); return Array.isArray(a) ? a : null; } catch (e) { return null; } }
  return null;
};
// What prints / shows for a section
export const pointsFor = sec => savedPoints(sec) ?? guideFor(sec?.section_name) ?? [];
